import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import {
    GenericHistoricMeteoData,
    GenericPrevisionMeteoData,
    GenericThermalSumMeteoData,
    GenericMeteoData,
    MeteoDataCache,
    ComposedHistoricMeteoData,
} from "./models";

export default class MeteoWidgetVuexModule extends AbacoVuexModule {
    @State({ default: {} }) historicMeteoData!: MeteoDataCache<ComposedHistoricMeteoData>;
    @State({ default: {} }) historicMeteoDataCalls!: MeteoDataCache<number>;

    @State({ default: {} }) previsionMeteoData!: MeteoDataCache<ComposedHistoricMeteoData>;
    @State({ default: {} }) previsionMeteoDataCalls!: MeteoDataCache<number>;

    @State({ default: {} }) thermalSumMeteoData!: MeteoDataCache<ComposedHistoricMeteoData>;
    @State({ default: {} }) thermalSumMeteoDataCalls!: MeteoDataCache<number>;

    @State({ default: [] }) curHistMeteoData!: GenericHistoricMeteoData[];
    @State({ default: [] }) curPrevMeteoData!: GenericPrevisionMeteoData[];
    @State({ default: [] }) curThermMeteoData!: GenericThermalSumMeteoData[];

    @State({ default: false }) globalHistLoader!: boolean;
    @State({ default: false }) globalPrevLoader!: boolean;
    @State({ default: false }) globalThermLoader!: boolean;

    @State({ default: false }) globalHistHasError!: boolean;
    @State({ default: false }) globalPrevHasError!: boolean;
    @State({ default: false }) globalThermHasError!: boolean;

    @State({
        default: [
            "AGRIMETEO_FULL_GOOD_SOWING_COND",
            "AGRIMETEO_FULL_TSUOLO_5CM",
            "AGRIMETEO_PREV_SOMMA_TERMICA",
            "LOT_EXPOSURE",
            "LOT_NITRATES_HAZARD",
            "LOT_TOPOGRAPHIC_PROFILE",
            "TIMAC_FLUORIMETRO",
            "AGRIMETEO_HIST_HUMIDITY",
            "AGRIMETEO_HIST_WIND",
            "AGRIMETEO_PT_HIST_METEO",
            "AGRIMETEO_PT_FULL_METEO",
            "AGRIMETEO_PT_HIST_HUMIDITY",
            "AGRIMETEO_PT_HIST_WIND",
            "COLDIRETTI_PREV_GELATE",
        ],
    })
    printableNewWidgetsCodes!: string[]; // widgets that can be printed outside the iframe, directly trough the global.ts component
}
